import { LibraryResponse } from 'lightning-common/lib/types/lightning-api';
import { supportArticles } from 'lightning-common/lib/configuration';
import { atom, RecoilValue } from 'recoil';

type LoadingState = 'error' | 'loaded' | 'loading' | 'not-started';

interface RawLibraryData {
    libraryData: LibraryResponse;
    loadingState: LoadingState;
    refresh?: () => void;
}

const DEFAULT_RAW_LIBRARY_DATA: RawLibraryData = {
    libraryData: {
        accountSignInUrl: '',
        apiFeatures: {},
        correlationId: '',
        deviceIsMac: false,
        deviceIsPreCatalinaMac: false,
        digitalCollectionType: '',
        dyslexic: false,
        enabledPlatforms: [],
        hasKanopySubscription: false,
        highContrast: false,
        isAuthenticated: false,
        isGdprCountry: false,
        isKindle: false,
        isWindows: false,
        kanopyImageUrls: undefined,
        kanopySignUpUrl: undefined,
        kindleUrl: '',
        languageList: [],
        libraryConfig: {},
        locale: 'en',
        mobileAlways: false,
        omc: false,
        pagesData: {
            items: [],
        },
        parentAccountKey: undefined,
        parentLocale: '',
        patronCanPlaceHolds: false,
        showHistoryFeature: false,
        supportUrl: '',
        bannerIsSecondaryColor: false,
        cardSignUpLink: null,
        contrast: false,
        defaultColor: '#222',
        enableGA: false,
        gacEnabled: false,
        isConsortium: false,
        isDLR: false,
        isTolinoDevice: false,
        library: {
            androidFooterUrl: '',
            androidUrl: '',
            iOSFooterUrl: '',
            iOSUrl: '',
            usesLibby: false,
            winUrl: '',
        },
        libraryConfigurations: {},
        libraryId: 0,
        libraryKey: '',
        libraryLinks: {},
        libraryName: '',
        LuckyDayLendingPeriodsByFormat: {},
        noIndex: false,
        primary: '#0D6693',
        primaryR: 13,
        primaryG: 102,
        primaryB: 147,
        primaryFontColor: '#fff',
        selectedCardId: '',
        secondary: '#74CDE2',
        secondaryR: 116,
        secondaryG: 205,
        secondaryB: 226,
        secondaryFontColor: '#000',
        showAccessEndingModal: false,
        showAdvantageTout: false,
        showCookieBanner: false,
        showCookieSettingsModal: false,
        showGetACardModal: false,
        showTlsWarningModal: undefined,
        socialLinks: {},
        socialLinksLength: 0,
        supportArticles: supportArticles,
        supportedFacets: [],
        supportedFormats: [],
        systemMessaging: {},
        tenant: 0,
        whitelistedMediaTypes: [],
    },
    loadingState: 'not-started',
};

export const rawLibraryDataState = atom<RawLibraryData>({
    key: 'RawLibraryData',
    default: DEFAULT_RAW_LIBRARY_DATA,
});

export const getLoadedLibraryData = (
    get: (recoilVal: RecoilValue<RawLibraryData>) => RawLibraryData
): LibraryResponse | undefined => {
    const rawLibraryData = get(rawLibraryDataState);
    return rawLibraryData.loadingState === 'loaded'
        ? rawLibraryData.libraryData
        : undefined;
};
